// Configuración de variables de entorno
const config = {
    // Key de Google para el autocompletado de direcciones del registro
    // (services/placesService.js). Va en el código a propósito, como toda key de
    // navegador: Google solo la acepta desde los dominios de la app y localhost:3000,
    // y solo para Places API (New). Se administra en Google Cloud, proyecto
    // transferisok, credencial "Registro web - Places (direcciones)".
    googleMapsApiKey: 'AIzaSyCDlBNuvk3U5FuYj_a_2ollYEIXtSSMxZw',
    // Aquí puedes agregar más variables de entorno según sea necesario
};

export default config; 